import React from 'react';
import { map } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { dispositionNotesWidget as DispositionNotesWidget } from 'ui/views/widgets/dispositionNotesWidget';

/**
 * @type { object }
 * @desc A React presentation/dumb view component.
 * @example
 * import { callDispositionNotes as CallDispositionNotes } from 'ui/views/widgets/callDispositionNotes';
 *
 * // render
 * <CallDispositionNotes propName='propValue'/>
 */

export const callDispositionNotesSuccess = ( props ) => {

	return (
		<div className='ui-call-disposition-notes'>
			<DispositionNotesWidget { ...props }/>
		</div>
	);
 };

// set display name
callDispositionNotesSuccess.displayName = 'callDispositionNotes';

// set default props
callDispositionNotesSuccess.defaultProps = {};

// prop types
callDispositionNotesSuccess.propTypes = {};

/*******************************/

// preloader view

export const callDispositionNotesPreloader = () => {
	return (
        <div className='ui-call-disposition-notes-preloader'>
            <div className='ui-call-disposition-notes-preloader__actions'>
                <div className='ui-call-disposition-notes-preloader__actions__button' />
            </div>

            <div className='ui-call-disposition-notes-preloader__items'>
                {
                    map( [ 1, 2 ], item => {
                        return (
                            <div key={ item } className='ui-call-disposition-notes-preloader__items__item'>
								<div className='ui-call-disposition-notes-preloader__items__item__header'>
									<div className='ui-call-disposition-notes-preloader__items__item__header__text' />
									<div className='ui-call-disposition-notes-preloader__items__item__header__actions' />
								</div>
								<div className='ui-call-disposition-notes-preloader__items__item__description'></div>
                            </div>
                        );
                    } )
                }
            </div>
        </div>
    );
 };

// set display name
callDispositionNotesPreloader.displayName = 'callDispositionNotesPreloader';

// set default props
callDispositionNotesPreloader.defaultProps = {};

// prop types
callDispositionNotesPreloader.propTypes = {};

/* ******************************************************* */

/**
 * @type { object }
 * @desc A React presentation/dumb view component.
 * @example
 * import { callDispositionNotes as CallDispositionNotes } from 'ui/views/widgets/callDispositionNotes';
 *
 * // render
 * <CallDispositionNotes propName='propValue'/>
 */

export const callDispositionNotes = withNetworkState(
	callDispositionNotesPreloader,
	callDispositionNotesSuccess
 );
